import GA4React from "ga-4-react"

export const trackPage = (options = {}) => {
    ga4.gtag('event', 'page_view', {
        page_location: window.location.href,
        page_path: window.location.pathname,
        ...options,   
    });
};

export let ga4 = { gtag: () => {} }
export const initGa4 = async (GaCode) => {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GaCode}`;
    
    script.setAttribute("nonce", "randomNonceValue"); // Add nonce attribute
  
    // Append script to the document head
    document.head.appendChild(script);
  
    // Wait for the script to load before initializing GA4React
    script.onload = async () => {
      const ga4react = new GA4React(GaCode);
      await ga4react.initialize();
    };

    // const ga4react = new GA4React(GaCode)
    // ga4 = await ga4react.initialize()

}
